<template>
  <DashboardChartLine
    :title="title"
    :labels="labels"
    :data="data"
    :height="height"
    :loading="loading"
    color="white"
    :bg-color="bgColor"
    dark
  />
</template>

<script>
import { dateFormatter } from '@/helpers/dateFormatter'
import DashboardChartLine from './DashboardChartLine.vue'
import variables from '@/assets/scss/exports.scss'

const DATE_FORMAT = 'D MMM'
const TITLE = 'Список авторизаций в день'

export default {
  name: 'DashboardChartLogins',
  components: {
    DashboardChartLine,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    loading: Boolean,
    color: String,
    dark: Boolean,
    height: null,
  },
  data: () => ({
    title: TITLE,
    bgColor: variables['color-success'],
  }),
  computed: {
    labels() {
      return this.list
        .map(({ date }) => dateFormatter(date, DATE_FORMAT))
    },
    data() {
      return this.list
        .map(({ count }) => count)
    },
  },
}
</script>
